<template>
    <div class="baseTree">
        <el-tree :expand-on-click-node="false" :data="Listdata" default-expand-all node-key="title" ref="tree"
            highlight-current :props="defaultProps">
            <span class="custom-tree-node-card" slot-scope="{ node, data }">
                <span>{{ node.label }}</span>
                <span class="operate">
                    <el-button class="base-button" type="text" size="mini" @click="() => append(node, data)">
                        添加下级
                    </el-button>
                    <el-button v-show="node.label != '监控中心'" class="base-button" type="text" size="mini"
                        @click="() => editNode(node, data)">
                        修改
                    </el-button>
                    <el-button v-show="node.label != '监控中心'" class="base-button" type="text" size="mini"
                        @click="() => remove(node, data)">
                        删除
                    </el-button>
                </span>
            </span>
        </el-tree>
    </div>
</template>
<script>
import { iViewTreeDeviceGroup, getlistDeviceLocation, deleteDeviceGroup } from "@/api/device/index.js";
import Add from "./add.vue";
import Edit from "./edit.vue"

export default {
    data() {
        return {
            Listdata: [
                {
                    id: 1,
                    model: "1_0",
                    title: '监控中心',
                    children: []
                }
            ],
            defaultProps: {
                children: 'children',
                label: 'title'
            },
            allCards: []
        };
    },
    created() {
        this.getTree();
    },
    mounted() {
        this.$bus.$on("card-list-m", () => {
            this.getTree();
        });
    },
    beforeDestroy() {
        this.$bus.$off("card-list-m");
    },
    methods: {
        append(node, data) {
            if (!data.model) {
                return;
            }
            this.$dialog.open({
                title: "添加节点",
                theme: "feature-dialog",
                shade: true,
                area: {
                    height: "280px",
                    width: "400px",
                },
                // location: {
                //     top: null,
                //     left: null,
                //     bottom: "300px",
                //     right: "20px",
                // },
                content: {
                    type: "vue",
                    subCom: Add,
                    subData: data
                },
            });
        },
        editNode(node, data) {
            if (!data.model) {
                return;
            }
            this.$dialog.open({
                title: "修改节点",
                theme: "feature-dialog",
                shade: true,
                area: {
                    height: "280px",
                    width: "400px",
                },
                // location: {
                //     top: null,
                //     left: null,
                //     bottom: "300px",
                //     right: "20px",
                // },
                content: {
                    type: "vue",
                    subCom: Edit,
                    subData: data
                },
            });
        },
        remove(node, data) {
            if (!data.model) {
                return;
            }
            var id = data.model.split("_")[1];
            this.$confirm(
                "删除分组后，下级分组将被删除，下属设备将被自动转移到父级，确定删除?",
                "提示",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }
            )
                .then(() => {
                    deleteDeviceGroup({ id: id }).then((res) => {


                        if (res && res.code == 200) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.$bus.$emit("card-list");
                            this.$bus.$emit("card-list-m");
                        }

                        if (!res || res.code != 200) {
                            this.$message({
                                type: "warning",
                                message: "删除失败:" + res.message,
                            });
                        }


                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        checkChange(item, bool, cBool) {
            if (!item.model) {
                return;
            }
            var car_num = item.model.split("_")[1];
            var card = this.findCardByNum(car_num);
            if (card) {
                var g = graphicLayer_Card.getGraphicById(car_num);
                if (!g) {
                    var p = Cesium.Cartesian3.fromDegrees(card.longitude, card.latitude);
                    g = this.createBillboardEntity(p, car_num);
                    graphicLayer_Card.addGraphic(g);
                }
                g.show = bool;
                map.flyToGraphic(g);
            }
        },
        //图标
        createBillboardEntity(center, id) {
            const graphic = new mars3d.graphic.BillboardEntity({
                id: id,
                position: center,
                style: {
                    image: "img/marker/mark2.png",
                    scale: 1.0,
                    horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                    verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                    clampToGround: false,
                },
            });
            return graphic;
        },
        findCardByNum(num) {
            var resList = this.allCards.filter(c => {
                return c.cardNumber == num;
            });

            return resList && resList.length > 0 ? resList[0] : undefined;
        },
        getAllCards() {
            getlistDeviceLocation().then(res => {
                this.allCards = res.result;
            }).catch(e => {
                console.error(e);
            });
        },
        getTree() {
            iViewTreeDeviceGroup().then(res => {

                var list = res.result || [];
                this.Listdata[0].children = list;

            }).catch(e => {
                console.error(e)
            });
        },
    },


};
</script>

<style lang="scss" scoped>
.search-top {
    margin-bottom: 20px;
}
</style>

<style>
.custom-tree-node-card {
    width: 100%;
    display: flex;
    align-items: center;
    font-size: 12px;
}

.custom-tree-node-card .operate {
    margin-left: 10px;
}
</style>